export const searchTypes = ['music', 'songlist', 'album', 'singer'] as const
export const searchTypeMap = {
  musicSearch: 'music',
  songlistSearch: 'songlist',
  albumSearch: 'album',
  singerSearch: 'singer',
} as const
